export default __webpack_public_path__ + "img/8ab0e6859f0f053d42639ba826ea1dd8.svg";